import gql from 'graphql-tag';

export default gql`
    mutation AssignDriverToLoad($driverId: Int, $loadId: Int, $isPrimaryDriver: Boolean) {
        assignDriverToLoad(driverId: $driverId, loadId: $loadId, isPrimaryDriver: $isPrimaryDriver) {
            errors
        }
    }
`;
